export default [
  { label: 'Naps', value: 'Naps' },
  { label: 'Plebe Summer', value: 'Plebe Summer' },
  { label: 'Plebe Academic Year', value: 'Plebe Academic Year' },
  { label: 'Youngster Cruise', value: 'Youngster Cruise' },
  { label: 'Youngster Academic Year', value: 'Younger Academic Year' },
  { label: 'PROTRAMID/ACTRAMID', value: 'PROTRAMID/ACTRAMID' },
  { label: '2nd Class Academic Year', value: '2nd Class Academic Year' },
  { label: 'First Class Cruise', value: 'First Class Cruise' },
  { label: 'First Class Academic Year', value: 'First Class Academic Year' },
  { label: 'June Week', value: 'June Week' }
]
